var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.019043 3.37948L6.46183 0.618286L11.9842 3.37948L17.7855 0.893209C18.0192 0.793088 18.2897 0.901299 18.3898 1.13491C18.4143 1.1922 18.427 1.25388 18.427 1.3162V16.2651L11.9842 19.0262L6.46183 16.2651L0.660523 18.7513C0.426908 18.8515 0.156376 18.7432 0.0562547 18.5096C0.0316985 18.4524 0.019043 18.3906 0.019043 18.3283V3.37948ZM12.9046 16.6291L16.5862 15.0512V3.40993L12.9046 4.98775V16.6291ZM11.0638 16.5079V4.97736L7.38223 3.13656V14.6671L11.0638 16.5079ZM5.54143 14.6567V3.01547L1.85984 4.59329V16.2346L5.54143 14.6567Z",
    fill: "#086AD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/Address.c4eecc530b06a5eef7334e30b677e411.svg";
export { ForwardRef as ReactComponent };